import { Model } from './model';

export class Association extends Model {
  id: number;
  name: string;
  acronym: string;

  public static apiMap(values: Object = {}) {
    return new Association(values);
  }

  constructor(values: Object = {}) {
    super(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/association.ts